import { render } from "./PerformanceChart.vue?vue&type=template&id=322e08dc&scoped=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=js"
export * from "./PerformanceChart.vue?vue&type=script&lang=js"

import "./PerformanceChart.vue?vue&type=style&index=0&id=322e08dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322e08dc"]])

export default __exports__